const validChars =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';

// Valid chars must be a power of 2, or the rng will be biased.
if (validChars.length !== 64) throw new Error('err');

/**
 * Generates a new ID for the database. 14 character (84 bits) by default.
 *
 * Note: Using birthday paradox calculator, at ~2^37 entries, there's a
 * <0.1% chance that two of them collide.
 */
export function generateId(len = 12) {
  const buf = new Uint8Array(len);
  globalThis.crypto.getRandomValues(buf);

  // The modulo is why we need the validChars to be of correct length.
  return Array.from(buf)
    .map((a) => validChars[a % validChars.length])
    .join('');
}
